import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowRight, ArrowLeft, Check } from 'lucide-react';
import { Reveal, TiltCard } from '../components/motion';
import { PRODUCTS, findProduct } from './productsData';
import { AIProductShowcase, VisibilitySection } from './sections';
import './productCategory.css';

const RELATED_SECTION = {
  'local-visibility': VisibilitySection,
  'ai-studio': AIProductShowcase,
  'how-it-works': null,
};

export default function ProductCategory() {
  const { slug } = useParams();
  const product = findProduct(slug);
  if (!product) return <Navigate to="/products" replace />;

  const Icon = product.icon;
  const Related = RELATED_SECTION[product.related];
  const others = PRODUCTS.filter(item => item.slug !== slug);

  return (
    <>
      <section className="product-hero">
        <Reveal className="product-hero-inner">
          <Link to="/products" className="tool-back"><ArrowLeft size={15} /> All products</Link>
          <div className="product-hero-main">
            <span className="product-hero-icon"><Icon size={26} /></span>
            <div>
              <div className="section-tag">{product.eyebrow}</div>
              <h1>{product.tagline}</h1>
            </div>
          </div>
          <p className="product-hero-summary">{product.summary}</p>
          <div className="page-hero-actions">
            <Link to="/signup" className="btn-primary">Get started <ArrowRight size={16} /></Link>
            <Link to="/pricing" className="btn-ghost">See which plan includes it</Link>
          </div>
        </Reveal>
      </section>

      <section className="product-detail">
        <div className="product-detail-grid">
          <Reveal className="product-detail-block">
            <h2 className="section-title">What’s included</h2>
            <ul className="product-feature-list">
              {product.features.map((feature, index) => (
                <li key={feature} style={{ '--i': index }}><Check size={15} />{feature}</li>
              ))}
            </ul>
          </Reveal>
          <Reveal className="product-detail-block" delay={90}>
            <h2 className="section-title">What it produces</h2>
            <div className="product-outcomes">
              {product.outcomes.map((outcome, index) => (
                <TiltCard as="article" className="product-outcome" intensity={7} lift={6} key={outcome} style={{ '--i': index }}>
                  <strong>{String(index + 1).padStart(2, '0')}</strong>
                  <span>{outcome}</span>
                </TiltCard>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {Related && <Related />}

      <section className="product-more">
        <Reveal className="section-header">
          <div className="section-tag">THE REST OF THE PLATFORM</div>
          <h2 className="section-title">Explore the other products.</h2>
          <p className="section-sub">Everything shares one customer record, so each product makes the next one stronger.</p>
        </Reveal>
        <div className="product-more-grid">
          {others.map((item, index) => {
            const OtherIcon = item.icon;
            return (
              <TiltCard as="article" className="product-more-card" intensity={6} lift={6} key={item.slug} style={{ '--i': index }}>
                <Link to={`/products/${item.slug}`}>
                  <span className="product-more-icon"><OtherIcon size={17} /></span>
                  <h3>{item.name}</h3>
                  <p>{item.tagline}</p>
                  <span className="product-more-cta">View product <ArrowRight size={13} /></span>
                </Link>
              </TiltCard>
            );
          })}
        </div>
      </section>
    </>
  );
}
